export const getStatusDisplayInfo = (status) => {
  switch (status) {
    case 'new':
      return { colorStatus: 'info', translatedStatus: 'Nouveau' }
    case 'open':
      return { colorStatus: 'primary', translatedStatus: 'Ouvert' }
    case 'pending':
      return { colorStatus: 'warning', translatedStatus: 'En attente' }
    case 'hold':
      return { colorStatus: 'warning', translatedStatus: 'En pause' }
    case 'closed':
    case 'solved':
      return { colorStatus: 'success', translatedStatus: 'Résolu' }
    default:
      return { colorStatus: 'default', translatedStatus: status }
  }
}
